import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { IoCheckmarkCircle, IoCloseCircle, IoWarning, IoReload, IoArrowForward } from "react-icons/io5";
import { ThreeDots } from 'react-loader-spinner';
import './css/auth.css';

const STATUS_CONFIG = {
    loading: {
        color: '#3b82f6',
        icon: <ThreeDots height="40" width="40" color="#3b82f6" />,
        title: 'Autenticando...',
        subtitle: 'Estamos validando suas credenciais em nossos servidores.'
    },
    200: {
        color: '#10b981',
        icon: <IoCheckmarkCircle size={60} color="#10b981" />,
        title: 'Sucesso!',
        subtitle: 'Sua conta foi verificada. Agora você tem acesso total à nossa plataforma.',
        buttonText: 'Ir para o Login'
    },
    400: {
        color: '#ef4444',
        icon: <IoCloseCircle size={60} color="#ef4444" />,
        title: 'Token Inválido',
        subtitle: 'Este link de autenticação parece estar corrompido ou é inválido.'
    },
    401: {
        color: '#f59e0b',
        icon: <IoWarning size={60} color="#f59e0b" />,
        title: 'Link Expirado',
        subtitle: 'Este link já expirou por segurança. Por favor, solicite um novo e-mail.'
    },
    error: {
        color: '#ef4444',
        icon: <IoCloseCircle size={60} color="#ef4444" />,
        title: 'Erro no Sistema',
        subtitle: 'Não conseguimos conectar ao servidor. Tente novamente em instantes.',
        showRetry: true
    }
};

function Auth() {
    const { authToken } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');

    
    useEffect(() => {
        handleAuthenticateToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleAuthenticateToken = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/auth/authenticate`, 
                { token: authToken, },
                {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_KEY
                    }
                }
            );

            setStatus(res.status);

        } catch (error) {
            const errorStatus = error.response?.status || 'error';
            setStatus(errorStatus);
        }
    };

    const config = STATUS_CONFIG[status] || STATUS_CONFIG['error'];

    return (
        <div className="auth-container">
            <AnimatePresence mode="wait">
                <motion.div 
                    key={status}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className="auth-card"
                >
                    <div className="status-icon">
                        {config.icon}
                    </div>
                    
                    <h1 className="auth-title">{config.title}</h1>
                    <p className="auth-subtitle">{config.subtitle}</p>

                    <div className="auth-actions">
                        {status === 200 && (
                            <button className="btn-primary" onClick={() => navigate('/login')}>
                                {config.buttonText} <IoArrowForward />
                            </button>
                        )}

                        {config.showRetry && (
                            <button className="btn-retry" onClick={() => window.location.reload()}>
                                Tentar Novamente <IoReload />
                            </button>
                        )}
                        
                        {(status === 400 || status === 401) && (
                            <button className="btn-secondary" onClick={() => navigate('/')}>
                                Voltar ao Início
                            </button>
                        )}
                    </div>

                    <div className="auth-footer">
                        <img src={require('../../images/Logo.png')} alt="Logo" className="auth-logo" />
                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    );
}

export default Auth;